<script setup lang="ts">
import { ref,reactive,computed,onMounted,onBeforeUnmount } from 'vue'
import CustomList from "../../../compositions/CustomList.vue";
import ModalDialog from "../../../compositions/ModalDialog.vue";
import CsvLoader from "../../../compositions/CsvLoader.vue";
import SearchBox from "../../../compositions/SearchBox.vue";
import SelectBox from "../../../compositions/SelectBox.vue";
import TextBox from "../../../compositions/TextBox.vue";
import CheckBox from "../../../compositions/CheckBox.vue";
import PharmacyMedicineEditComponent from "../../Common/PharmacyMedicineEditComponent.vue";
import config from "../../../config.js";
import { errorAlert,confirmAlert,successAlert } from "../../../plugins/alert";
import { getFieldValue } from "../../../plugins/utility";
import { getHeadMedicineMark } from "../../../plugins/pharmacy";
import qs from 'qs';
import axios from '../../../plugins/axios.ts';
import HelpAction from '../../../compositions/HelpAction.vue';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    pharmacyWholesalers:{
      type:Array,
      required:true,
    },
    placeHolder:{
        type:String,
        default: () => {
            return '';
        }
    }
})
const listRef = ref();
const searchWord = ref('');
const onSearchWordChange = (value) => {
  searchWord.value = value;
}
const onSearchWordEnter = (value) => {
  searchWord.value = value;
  listSearch();
}
const fields = ref([
  {field_name: '棚番', field_key: 'storage_bin', width: '8%', align: 'text-center', sorted:true},
  {field_name: '採用品', field_key: 'product_name', width: '15%', align: 'text-left', sorted:true},
  {field_name: '経過措置', field_key: 'medicine.transitional_measure_date', width: '8%', align: 'text-center', sorted:true},
  {field_name: '分類', field_key: 'warning_mark', width: '6%', align: 'text-center', sorted:true},
  {field_name: '販売元', field_key: 'seller_name', width: '10%', align: 'text-left', sorted:true},
  {field_name: 'コード', field_key: 'medicine_code_info', width: '10%', align: 'text-left', sorted:false},
  {field_name: '予測切替先', field_key: 'predict_product_name', width: '15%', align: 'text-left', sorted:true},
  {field_name: '販売元', field_key: 'predict_seller_name', width: '10%', align: 'text-left', sorted:true},
  {field_name: '卸業者', field_key: 'wholesaler_name', width: '10%', align: 'text-center', sorted:true},
  {field_name: '', field_key: 'alert_wholesaler', width: '5%', align: 'text-center', sorted:true},
  {field_name: '', field_key: 'action_edit', width: '5%', align: 'text-center'},
]);

const isLoadingDialog = ref(false);
const isUploadFileDialog = ref(false);
const isUploadFileLoading = ref(false);
const headerLine = ref(0);
const g1CodeLine = ref(0);
const wholesalerLine = ref(0);
const storageBin1Line = ref(0);
const storageBin2Line = ref(0);
const storageBin3Line = ref(0);
const uploadFile = ref(new Object());
const uploadFileData = ref([]);
const g1List = ref([]);
const wholesalerList = ref([]);
const storageBinList = ref([]);
const medicineIds = reactive([]);
const medicineOptions = reactive([]);
const optionFields = ref({
  'search_word' : searchWord.value,
  'medicine_ids':medicineIds,
  'page_size' : 30,
});
const listSearch = (delay=0) => {
  optionFields.value.search_word = searchWord.value;
  optionFields.value.medicine_ids = medicineIds;
  listRef.value.resetItem(delay);
}
const handler = (name:string,value:Object,eof:Boolean=false) => {
  if (name == 'item') {
  }
}
const uploadFilehandler = (value:Object) => {
  uploadFile.value = value;
}
const uploadStart = () => {
  isUploadFileLoading.value = true;
}
const uploadComplete = (data) => {
  // 表示するために最大30データをセットする
  uploadFileData.value.splice(0);
  g1List.value.splice(0);
  wholesalerList.value.splice(0);
  storageBinList.value.splice(0);
  if (data.length > 0) {
    g1List.value.push('　');
    wholesalerList.value.push('　');
    storageBinList.value.push('　');
    for (let i=0;i<data[0].length;i++) {
      g1List.value.push(data[0][i]);
      wholesalerList.value.push(data[0][i]);
      storageBinList.value.push(data[0][i]);
    }
  }
  for (let i=0;i<data.length;i++) {
    if (i > 30) {
      break;
    }
    uploadFileData.value.push(data[i]);
  }
  isUploadFileLoading.value = false;
  //
}
const showUploadFileDialog = () => {
  isUploadFileDialog.value = true;
}
const closeUploadFileDialog = () => {
  isUploadFileDialog.value = false;
}
const uploadFileDataResult = async () => {
  if (!uploadFile.value) {
    errorAlert('ファイルを選択してください。');
    return;
  }
  if (g1CodeLine.value == 0) {
    errorAlert('JANコード読み込み列は必須です。');
    return;
  }
  if (wholesalerLine.value == 0) {
    errorAlert('卸コード読み込み列は必須です。');
    return;
  }
  let params = new FormData();
  params.append('upload_file', uploadFile.value);
  params.append('header_line', headerLine.value);
  params.append('g1_line', g1CodeLine.value);
  params.append('wholesaler_line', wholesalerLine.value);
  params.append('storage_bin1_line', storageBin1Line.value);
  params.append('storage_bin2_line', storageBin2Line.value);
  params.append('storage_bin3_line', storageBin3Line.value);
  isUploadFileLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_medicine_update_file,{method:"post",data:params});
    if (response.data.status == 200) {
      successAlert('更新処理を予約しました。反映まで数分かかる場合がございますので、しばらくお待ちください。完了しましたらログインしたメールアドレスに通知致します。');
      closeUploadFileDialog();
    }
  } finally {
    isUploadFileLoading.value = false;
  }
}
const yjCode = ref('');
const isEditPharmacyMedicineDialog = ref(false);
const showEditPharmacyMedicine = (item) => {
  if (item != null) {
    yjCode.value = item.medicine.yj_code;
  } else {
    yjCode.value = '';
  }
  isEditPharmacyMedicineDialog.value = true;
}
const closeEditPharmacyMedicine = () => {
  isEditPharmacyMedicineDialog.value = false;
  yjCode.value = '';
}
const updateCompleteMedicine = (data) => {
  for (let i=0;i<data.length;i++) {
    let item = listRef.value.getItemById(data[i].pharmacy_medicine_id);
    if (item == null) {
      //新規追加があるのでリストをリフレッシュする
      listSearch(config.LIST_DELAY);
      break;
    } else if (data[i].medicine_predict_exists) {
      //新規追加があるのでリストをリフレッシュする
      listSearch(config.LIST_DELAY);
      break;
    } else {
      if (data[i].is_deleted) {
        listRef.value.deleteItem(item);
      } else {
        item = data[i];
        listRef.value.updateItem(item);
      }
    }
  }
  closeEditPharmacyMedicine();
}
//販売元一括返還
const isEditSellerDialog = ref(false);
const isEditSellerLoading = ref(false);
const srcSellerId = ref(0);
const destSellerId = ref(0);
const onSellerChange = (value,label,options) => {
  if (options.type == 'src') {
    srcSellerId.value = value;
  } else {
    destSellerId.value = value;
  }
}
const showEditSeller = (item) => {
  srcSellerId.value = 0;
  destSellerId.value = 0;
  isEditSellerDialog.value = true;
}
const closeEditSeller = () => {
  isEditSellerDialog.value = false;
}
const updateSeller = async (data) => {
  if (srcSellerId.value == 0) {
    errorAlert('変更前の販売元を指定してください。');
    return;
  }
  if (destSellerId.value == 0) {
    errorAlert('変更後の販売元を指定してください。');
    return;
  }
  let params = new FormData();
  params.append('src_seller_id', srcSellerId.value);
  params.append('dest_seller_id', destSellerId.value);
  isEditSellerLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_medicine_seller_update,{method:"post",data:params});
    if (response.data.status == 200) {
      listSearch(config.LIST_DELAY);
      closeEditSeller();
    }
  } finally {
    isEditSellerLoading.value = false;
  }
}
//卸業者一括変換
const isEditAllWholesalerDialog = ref(false);
const isEditAllWholesalerLoading = ref(false);
const srcWholesalerSellerId = ref(0);
const destWholesalerId = ref(0);
const onAllWholesalerChange = (value,label,options) => {
  if (options.type == 'src') {
    srcWholesalerSellerId.value = value;
  } else {
    destWholesalerId.value = value;
  }
}
const showEditAllWholesaler = (item) => {
  srcWholesalerSellerId.value = 0;
  destWholesalerId.value = 0;
  isEditAllWholesalerDialog.value = true;
}
const closeEditAllWholesaler = () => {
  isEditAllWholesalerDialog.value = false;
}
const updateAllWholesaler = async (data) => {
  if (srcWholesalerSellerId.value == 0) {
    errorAlert('販売元を指定してください。');
    return;
  }
  if (destWholesalerId.value == 0) {
    errorAlert('卸業者を指定してください。');
    return;
  }
  let params = new FormData();
  params.append('src_seller_id', srcWholesalerSellerId.value);
  params.append('dest_wholesaler_id', destWholesalerId.value);
  isEditAllWholesalerLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_medicine_wholesaler_update,{method:"post",data:params});
    if (response.data.status == 200) {
      listSearch(config.LIST_DELAY);
      closeEditAllWholesaler();
    }
  } finally {
    isEditAllWholesalerLoading.value = false;
  }
}

const pharmacyMedicineDownload = () => {
  let params = {};
  params['is_download'] = 1;
  //全てのデータを取得するのでページサイズを0にする
  params['page_size'] = 0;
  params['p'] = 1;
  const queryParameter = qs.stringify(params,{ arrayFormat: 'repeat'});
  window.open(props.apis.pharmacy_medicine_list + '?' + queryParameter,'_blank');
}
/////// 検索機能追加 ////////////
const onMedicineSelectChange = (values) => {
    medicineIds.splice(0);
    for (let i=0;i<values.length;i++) {
        medicineIds.push(values[i]);
    }
    listSearch();
}
///////////////////////////////
const selectLineColor = computed(() => {
  return (index) => {
    let result = '';
    if (index == g1CodeLine.value) {
      result = 'g1-color';
    } else if (index == wholesalerLine.value) {
      result = 'wholesaler-color';
    } else if (index == headerLine.value) {
      result = 'header-color';
    } else if (index == storageBin1Line.value) {
      result = 'storage-bin1-color';
    } else if (index == storageBin2Line.value) {
      result = 'storage-bin2-color';
    } else if (index == storageBin3Line.value) {
      result = 'storage-bin3-color';
    }
    return result;
  }
})
</script>

<style scoped>
.header-color {
  background-color: #bab8b8;
}
.g1-color {
  background-color: rgb(253, 253, 76);
}
.wholesaler-color {
  background-color: rgb(94, 251, 107);
}
.storage-bin1-color {
  background-color: rgb(251, 94, 251);
}
.storage-bin2-color {
  background-color: rgb(134, 40, 134);
}
.storage-bin3-color {
  background-color: rgb(150, 114, 150);
}
</style>
<template>
<div ref="element" class="relative">
  <div class="absolute top-2 left-2">
    <help-action
      help-key="pharmacy_medicine_help"
    ></help-action>
  </div>
  <div class="w-full flex items-center justify-end p-2 bg-gray-100 rounded">
      <div class="m-1">
          <select-box
              :api-url="apis.medicine_list"
              :api-option-fields="{relation_pharmacy:1,is_relation:1,page_size:20}"
              :on-change="onMedicineSelectChange"
              :value="medicineIds"
              list-field-name="product_detail_name"
              :options="medicineOptions"
              :is-multi="true"
              place-holder="採用品を選択"
              list-height="20em"
          ></select-box>
      </div>
      <div class="m-1">
        <search-box
          :search-word="searchWord"
          :on-change="onSearchWordChange"
          :on-enter="onSearchWordEnter"
          place-holder="採用品名を入力"
      ></search-box>
      </div>
      <!--
      <div class="m-1">
          <a href="javascript:void(0)" @click="showEditSeller" class="block text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 font-medium rounded-lg text-base px-5 py-3 w-full sm:w-auto text-center ml-2">販売元一括変換</a>
      </div>
      -->
      <div class="m-1">
          <a href="javascript:void(0)" @click="showEditAllWholesaler" class="block text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 font-medium rounded-lg text-base px-5 py-3 w-full sm:w-auto text-center ml-2">卸業者一括変換</a>
      </div>
      <div class="m-1">
          <a href="javascript:void(0)" @click="showUploadFileDialog" class="block text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 font-medium rounded-lg text-base px-5 py-3 w-full sm:w-auto text-center ml-2">採用品ファイル読み込み</a>
      </div>
      <div class="m-1">
        <a href="javascript:void(0)" @click="showEditPharmacyMedicine(null)" class="block text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 font-medium rounded-lg text-base px-5 py-3 w-full sm:w-auto text-center ml-2">採用品追加</a>
      </div>
      <div class="m-1">
          <a href="javascript:void(0)" @click="pharmacyMedicineDownload" class="block text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 font-medium rounded-lg text-base px-5 py-3 w-full sm:w-auto text-center ml-2">採用品出力</a>
      </div>
  </div>
  <div class="w-full">
      <custom-list
        ref="listRef"
        :table-fields="fields"
        :option-fields="optionFields"
        :api-url="apis.pharmacy_medicine_list"
        height="72vh"
        :handler="handler"
      >
      <template v-slot:item="slotProps">
        <td v-for="(field,index) in fields" :key="index" :style="'width:' + field.width" class="text-center">
          <div v-if="field.field_key == 'action_edit'" :class="field.align">
            <a href="javascript:void(0)" @click="showEditPharmacyMedicine(slotProps.item)"><i class="fa-regular fa-pen-to-square"></i></a>
          </div>
          <div v-else-if="field.field_key == 'alert_wholesaler'" :class="field.align">
            <i v-show="slotProps.item.wholesaler_id == null" class="fa-solid fa-car-burst"></i>
          </div>
          <div v-else-if="field.field_key == 'warning_mark'" :class="field.align">
            <span v-html="slotProps.item.medicine.warning_mark"></span>
          </div>
          <div v-else-if="field.field_key == 'product_name'" :class="field.align" v-html="(slotProps.item.product_name + ' ' + slotProps.item.medicine.package_label + ' ' + (slotProps.item.is_head_managed ? getHeadMedicineMark() : ''))"></div>
          <div v-else-if="field.field_key == 'predict_product_name'" :class="field.align">
            {{ slotProps.item.medicine_predict ? slotProps.item.medicine_predict.product_name + ' ' + slotProps.item.medicine_predict.package_label : '' }}
          </div>
          <div v-else-if="field.field_key == 'seller_name'" :class="field.align">
            {{ slotProps.item.medicine.seller_name }}
          </div>
          <div v-else-if="field.field_key == 'wholesaler_name'" :class="field.align">
            {{ (slotProps.item.wholesaler != null ? slotProps.item.wholesaler.wholesaler_common_name : '-') }}
          </div>
          <div v-else-if="field.field_key == 'predict_seller_name'" :class="field.align">
            {{ slotProps.item.medicine_predict ? slotProps.item.medicine_predict.seller_name : '' }}
          </div>
          <div v-else-if="field.field_key == 'medicine_code_info'" :class="field.align">
            <div>JANコード:{{ (slotProps.item.jan_code ? slotProps.item.jan_code : '') }}</div>
            <div>包装コード:{{ (slotProps.item.dispensing_packaging_unit_code ? slotProps.item.dispensing_packaging_unit_code : '') }}</div>
            <div>販売コード:{{ (slotProps.item.sales_packaging_unit_code ? slotProps.item.sales_packaging_unit_code : '') }}</div>
          </div>
          <div v-else :class="field.align">
            {{ getFieldValue(slotProps.item,field.field_key) }}
          </div>
        </td>
      </template>
      </custom-list>
  </div>
</div>
<modal-dialog
  :is-visible="isLoadingDialog"
  width="40%"
  :isLoading="true"
>
  <template v-slot:header>
  </template>
  <template v-slot:default>
  <div class="mb-6">
    処理中です。
  </div>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isEditPharmacyMedicineDialog"
  width="95%"
  :close="closeEditPharmacyMedicine"
>
  <template v-slot:header>
    採用品編集
  </template>
  <template v-slot:default>
    <pharmacy-medicine-edit-component
      :apis="apis"
      :yj-code="yjCode"
      :pharmacy-wholesalers="pharmacyWholesalers"
      :is-medicine-fix="yjCode ? true : false"
      :is-deletable="true"
      :cancel="closeEditPharmacyMedicine"
      :updateComplete="updateCompleteMedicine"
    ></pharmacy-medicine-edit-component>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isEditSellerDialog"
  width="60%"
  :close="closeEditSeller"
  :is-loading="isEditSellerLoading"
>
  <template v-slot:header>
    販売元一括変換
  </template>
  <template v-slot:default>
    <div class="md:border p-2">
      <table class="w-full">
        <thead>
          <tr>
            <th>変更前</th>
            <th>変更後</th>
          </tr>
        </thead>
        <tbody>
          <tr class="border-b border-white">
            <td class="block py-3 text-sm md:table-cell md:px-3 md:py-2">
              <select-box
                :value="srcSellerId"
                :options="[]"
                list-field-name="seller_name"
                list-id-name="delivery_code"
                :value-options="{type:'src'}"
                :on-change="onSellerChange"
                :api-url="apis.pharmacy_medicine_seller_list"
                place-holder="販売元を選択"
              ></select-box>
            </td>
            <td class="block py-3 text-sm md:table-cell md:px-3 md:py-2">
              <select-box
                :value="destSellerId"
                :options="[]"
                list-field-name="seller_name"
                list-id-name="delivery_code"
                :value-options="{type:'dest'}"
                :on-change="onSellerChange"
                :api-url="apis.pharmacy_medicine_seller_list"
                place-holder="販売元を選択"
              ></select-box>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex">
      <div class="flex-row mr-2">
        <button type="button" @click="updateSeller" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">一括変換する</button>
      </div>
      <div class="flex-row">
        <button type="button" @click="closeEditSeller" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
      </div>
    </div>

  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isEditAllWholesalerDialog"
  width="60%"
  :close="closeEditAllWholesaler"
  :is-loading="isEditAllWholesalerLoading"
>
  <template v-slot:header>
    卸業者一括変換
  </template>
  <template v-slot:default>
    <div class="md:border p-2">
      <table class="w-full">
        <thead>
          <tr>
            <th>販売元</th>
            <th>変更後卸業者</th>
          </tr>
        </thead>
        <tbody>
          <tr class="border-b border-white">
            <td class="block py-3 text-sm md:table-cell md:px-3 md:py-2">
              <select-box
                :value="srcWholesalerSellerId"
                :options="[]"
                list-field-name="seller_name"
                list-id-name="delivery_code"
                :value-options="{type:'src'}"
                :on-change="onAllWholesalerChange"
                :api-url="apis.pharmacy_medicine_seller_list"
                place-holder="販売元を選択"
              ></select-box>
            </td>
            <td class="block py-3 text-sm md:table-cell md:px-3 md:py-2">
              <select-box
                :value="destWholesalerId"
                :options="pharmacyWholesalers"
                list-field-name="wholesaler_name"
                :value-options="{type:'dest'}"
                :on-change="onAllWholesalerChange"
                :is-searchable="false"
                place-holder="卸業者を選択"
              ></select-box>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex">
      <div class="flex-row mr-2">
        <button type="button" @click="updateAllWholesaler" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">一括更新する</button>
      </div>
      <div class="flex-row">
        <button type="button" @click="closeEditAllWholesaler" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
      </div>
    </div>

  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isUploadFileDialog"
  width="60%"
  :close="closeUploadFileDialog"
  :isLoading="isUploadFileLoading"
>
  <template v-slot:header>
    採用品ファイル読み込み
  </template>
  <template v-slot:default>
  <div class="mb-6">
    <div class="mb-3 px-3 py-2 md:mb-0 md:rounded-t">
      <p class="text-lg font-bold">読み込み設定</p>
    </div>
    <div class="md:border p-2">
      <table class="w-full">
        <tr class="border-b border-white">
          <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">採用品ファイル選択(CSVファイル) <span class="inline-block px-1 text-xs font-bold text-red-500 rounded">必須</span></th>
          <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
            <csv-loader
              :value="uploadFile"
              :handler="uploadFilehandler"
              :loadStart="uploadStart"
              :loadComplete="uploadComplete"
            ></csv-loader>
          </td>
        </tr>
        <tr class="border-b border-white">
          <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">ヘッダ行指定 <span class="header-color">　</span></th>
          <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
            <input class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="number" v-model="headerLine" placeholder="">
          </td>
        </tr>
        <tr class="border-b border-white">
          <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">JANコード読み込み列  <span class="g1-color">　</span><span class="inline-block px-1 text-xs font-bold text-red-500 rounded">必須</span></th>
          <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
            <select class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" v-model="g1CodeLine">
              <option v-for="(g1Value,index) in g1List" :key="index" :value="index">{{ g1Value }}</option>
            </select>
          </td>
        </tr>
        <tr class="border-b border-white">
          <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">卸コード読み込み列  <span class="wholesaler-color">　</span><span class="inline-block px-1 text-xs font-bold text-red-500 rounded">必須</span></th>
          <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
            <select class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" v-model="wholesalerLine">
              <option v-for="(wholesalerValue,index) in wholesalerList" :key="index" :value="index">{{ wholesalerValue }}</option>
            </select>
          </td>
        </tr>
        <tr class="border-b border-white">
          <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">棚番列１読み込み列  <span class="storage-bin1-color">　</span></th>
          <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
            <select class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" v-model="storageBin1Line">
              <option v-for="(storageVinValue,index) in storageBinList" :key="index" :value="index">{{ storageVinValue }}</option>
            </select>
          </td>
        </tr>
        <tr class="border-b border-white">
          <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">棚番列２読み込み列  <span class="storage-bin2-color">　</span></th>
          <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
            <select class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" v-model="storageBin2Line">
              <option v-for="(storageVinValue,index) in storageBinList" :key="index" :value="index">{{ storageVinValue }}</option>
            </select>
          </td>
        </tr>
        <tr class="border-b border-white">
          <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">棚番列３読み込み列  <span class="storage-bin3-color">　</span></th>
          <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
            <select class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" v-model="storageBin3Line">
              <option v-for="(storageVinValue,index) in storageBinList" :key="index" :value="index">{{ storageVinValue }}</option>
            </select>
          </td>
        </tr>
      </table>
    </div>
    <div class="md:border p-2 h-40 overflow-auto">
      <table class="table-auto whitespace-nowrap min-w-full border text-center">
        <tr class="bg-white border-b " v-for="(csvData,index1) in uploadFileData" :key="index1">
          <td class="border-r bg-gray-400">
            {{ index1+1 }}
          </td>
          <td :class="'border-r ' + ((index1+1) == headerLine ? 'header-color' : selectLineColor(index2+1))" v-for="(csv,index2) in csvData" :key="index2">
            {{ csv }}
          </td>
        </tr>
      </table>
    </div>
    <div class="flex">
      <div class="flex-row mr-2">
        <button type="button" @click="uploadFileDataResult" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">取り込む</button>
      </div>
      <div class="flex-row">
        <button type="button" @click="closeUploadFileDialog" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
      </div>
    </div>
  </div>
  </template>
</modal-dialog>
</template>

